if (!customElements.get('ae-faq')) {
    customElements.define('ae-faq', class AEFaq extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                toggle: '.js-faq-toggle'
            }

            this.toggles = this.querySelectorAll(this.selectors.toggle);
            this.init();
        }

        init() {
            console.log(   this.toggles)
            this.toggles.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    el.classList.toggle('is-active');
                })
            })
        }
    })
}